export const getImageHeight = ({ dynamicWidth }) => {
  if (dynamicWidth < 1200) return 190;

  if (dynamicWidth < 1920) return 240;

  return 400;
};
